export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-100/60 text-primary-600 text-xs font-medium mb-4">
                平台介绍
              </span>
              <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading mb-5">
                关于红桃影视
              </h2>
              <div className="space-y-4 text-sm text-foreground-500 leading-relaxed max-w-lg mx-auto lg:mx-0">
                <p>
                  红桃影视是一个专注于高清电视剧在线观看的平台，致力于为剧迷提供最全面、最便捷的追剧体验。我们收录了海量大陆剧、韩剧、港剧、台剧、日剧等热门剧集资源，覆盖古装、悬疑、爱情、都市、奇幻等多种类型。
                </p>
                <p>
                  平台上线以来，始终坚持"免费、高清、无广告"的核心理念，每日同步更新最新剧集。无论是热播国产大剧还是高分海外佳作，用户都可以在红桃影视找到完整全集，享受流畅的观影体验。
                </p>
                <p>
                  我们拥有一支热爱影视的专业团队，精心筛选每部剧集的内容质量，确保为用户提供优质的观影选择。未来，红桃影视将继续扩展剧集资源，优化播放体验，成为剧迷心中最值得信赖的在线追剧平台。
                </p>
              </div>

              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-6">
                <div className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-400 font-heading">500万+</div>
                  <div className="text-xs text-foreground-500 mt-1">月活跃用户</div>
                </div>
                <div className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-accent-500 font-heading">99.7%</div>
                  <div className="text-xs text-foreground-500 mt-1">用户好评率</div>
                </div>
                <div className="text-center">
                  <div className="text-xl md:text-2xl font-bold text-secondary-400 font-heading">3年</div>
                  <div className="text-xs text-foreground-500 mt-1">稳定运营</div>
                </div>
              </div>
            </div>

            <div className="flex-1 w-full max-w-md lg:max-w-none">
              <div className="relative">
                <div className="absolute -inset-2 bg-gradient-to-r from-primary-500/10 to-accent-500/10 rounded-2xl blur-lg"></div>
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cozy%20modern%20living%20room%20with%20a%20large%20TV%20screen%20displaying%20a%20dramatic%20Chinese%20period%20drama%20scene%2C%20warm%20ambient%20lighting%2C%20comfortable%20sofa%2C%20cinematic%20atmosphere%2C%20home%20theater%20setup%2C%20evening%20mood%2C%20photorealistic%20interior%20design&width=800&height=600&seq=about-img-2026-x1&orientation=landscape"
                  alt="红桃影视居家观影场景"
                  className="relative w-full rounded-2xl object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}